import { Class } from './types';

export const mockClasses: Class[] = [
  {
    id: 'class-003',
    name: 'Math 3A',
    grade: '3',
    teacherId: 'teacher-001',
    schoolId: 'school-001',
    students: ['student-021', 'student-022', 'student-023', 'student-024', 'student-025', 'student-026', 'student-027', 'student-028', 'student-029', 'student-030'],
    learningPaths: ['path-004'],
    schoolYear: '2024-2025',
    status: 'active',
    teachers: ['teacher-001', 'teacher-002']
  },
  {
    id: 'class-001',
    name: 'Math 5A',
    grade: '5',
    teacherId: 'teacher-001',
    schoolId: 'school-001',
    students: ['student-001', 'student-002', 'student-003', 'student-004', 'student-005', 'student-006', 'student-007', 'student-008', 'student-009', 'student-010'],
    learningPaths: ['path-001', 'path-002'],
    schoolYear: '2024-2025',
    status: 'active',
    teachers: ['teacher-001']
  },
  {
    id: 'class-002',
    name: 'Math 5B',
    grade: '5',
    teacherId: 'teacher-001',
    schoolId: 'school-001',
    students: ['student-011', 'student-012', 'student-013', 'student-014', 'student-015', 'student-016', 'student-017', 'student-018', 'student-019', 'student-020'],
    learningPaths: ['path-001', 'path-003'],
    schoolYear: '2024-2025',
    status: 'active',
    teachers: ['teacher-001', 'teacher-005']
  },
  {
    id: 'class-004',
    name: 'Math 4A',
    grade: '4',
    teacherId: 'teacher-003',
    schoolId: 'school-002',
    students: ['student-031', 'student-032', 'student-033', 'student-034', 'student-035', 'student-036', 'student-037', 'student-038', 'student-039', 'student-040'],
    learningPaths: ['path-005'],
    schoolYear: '2023-2024',
    status: 'archived',
    teachers: ['teacher-003']
  },
  {
    id: 'class-005',
    name: 'Math 2A',
    grade: '2',
    teacherId: 'teacher-004',
    schoolId: 'school-002',
    students: ['student-041', 'student-042', 'student-043', 'student-044', 'student-045', 'student-046', 'student-047', 'student-048', 'student-049', 'student-050'],
    learningPaths: ['path-006'],
    schoolYear: '2024-2025',
    status: 'active',
    teachers: ['teacher-004']
  },
  {
    id: 'class-006',
    name: 'Math 1A',
    grade: '1',
    teacherId: 'teacher-002',
    schoolId: 'school-001',
    students: ['student-051', 'student-052', 'student-053', 'student-054', 'student-055'],
    learningPaths: ['path-007'],
    schoolYear: '2024-2025',
    status: 'active',
    teachers: ['teacher-002']
  },
  {
    id: 'class-007',
    name: 'Math 6A',
    grade: '6',
    teacherId: 'teacher-005',
    schoolId: 'school-003',
    students: ['student-056', 'student-057', 'student-058', 'student-059', 'student-060'],
    learningPaths: ['path-008'],
    schoolYear: '2024-2025',
    status: 'active',
    teachers: ['teacher-005']
  },
  {
    id: 'class-008',
    name: 'Math 3B',
    grade: '3',
    teacherId: 'teacher-002',
    schoolId: 'school-001',
    students: [],
    learningPaths: [],
    schoolYear: '2024-2025',
    status: 'inactive',
    teachers: ['teacher-002']
  }
];